import { createReducer, on } from "@ngrx/store";

export const contractFeatureKey = "contract";

export interface ContractState {

}

export const initialState: ContractState = {

};

export const contractReducer = createReducer(
	initialState,
);
